import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    scheduleFilters: {
        ScheduleCode: '',
        Survey_from_date: '',
        Survey_end_date: '',
        TechnologyId: '',
        WorksiteId: '',
        EmployeeId: '',
        EquipmentID: '',
        project: '',
        ScheduleStatus: '',
        schedule_process_status: ''
    },
};

const scheduleFilterSlice = createSlice({
    name: `scheduleFilters`,
    initialState,
    reducers: {
        setScheduleFilters: (state, action) => {
            state.scheduleFilters = action.payload;
        },
        resetScheduleFilters: (state) => {
            state.scheduleFilters = initialState.scheduleFilters;
        }
    }
})

export const { setScheduleFilters, resetScheduleFilters } = scheduleFilterSlice.actions
export default scheduleFilterSlice.reducer;